import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
interface AccordionItemProps {
  emoji: string;
  title: string;
  description: string;
  badge?: string;
  index: number;
}
// Single collapsible item used for modules and bonuses.
export function AccordionItem({
  emoji,
  title,
  description,
  badge,
  index
}: AccordionItemProps) {
  const [open, setOpen] = useState(false);
  const contentId = `acc-${title.replace(/\s+/g, '-').toLowerCase()}`;
  return <div className="overflow-hidden rounded-xl border border-[#c8a24a]/30 bg-[#0b2545]/80 backdrop-blur-sm" data-id="element-15">
      <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-controls={contentId} className="flex w-full items-center gap-3 px-4 py-4 text-left" data-id="element-16">
        <span className="flex h-8 w-8 flex-none items-center justify-center rounded-lg bg-[#c8a24a]/15 text-lg" aria-hidden="true" data-id="element-17">
          {emoji}
        </span>
        <span className="flex min-w-0 flex-1 flex-col" data-id="element-18">
          <span className="text-sm font-bold leading-snug text-white" data-id="element-19">
            {title}
          </span>
          {badge && <span className="mt-1 w-fit rounded-full bg-[#c8a24a] px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-[#061a33]" data-id="element-20">
              {badge}
            </span>}
        </span>
        <motion.span animate={{
        rotate: open ? 180 : 0
      }} transition={{
        duration: 0.2
      }} className="flex-none text-[#c8a24a]" data-id="element-21">
          <ChevronDownIcon className="h-5 w-5" aria-hidden="true" data-id="element-22" />
        </motion.span>
      </button>
      <AnimatePresence initial={false} data-id="element-23">
        {open && <motion.div id={contentId} initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.25,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-24">
            <p className="border-t border-[#c8a24a]/20 px-4 py-3 text-sm leading-relaxed text-blue-100/90" data-id="element-25">
              {description}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}